<template>
  <v-data-table
    v-bind="$attrs"
    :headers="mappedHeaders"
    v-on="$listeners"
  >
    <template
      v-for="(_, slotName) in $scopedSlots"
      #[slotName]="slotProps"
    >
      <slot
        :name="slotName"
        v-bind="slotProps"
      />
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "EkitabuDataTable",
  inheritAttrs: false,
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    mappedHeaders() {
      // Vuetify 2: pass headers through untouched.
      // Vuetify 3 cutover: remap here (text -> title, value -> key) so the
      // ~9 call sites keep their existing { text, value } header shape.
      return this.headers;
    },
  },
};
</script>
